<button mat-mini-fab class="m-1" color="primary" (click)="openQuickActionDialog()" matTooltip="Quick Action">
  <mat-icon>offline_bolt</mat-icon>
</button>

<button mat-mini-fab class="m-1" color="primary" (click)="openRegisterShoppingDialog()" matTooltip="Register Shopping">
  <mat-icon>shopping_cart</mat-icon>
</button>

<button mat-mini-fab class="m-1" color="primary" (click)="openVolatileStockDialog()" matTooltip="Volatile Stock">
  <mat-icon>warning</mat-icon>
</button>

<button
  mat-mini-fab
  class="m-1"
  color="primary"
  (click)="openLogWeightedHarvestDialog()"
  matTooltip="Log Weighted Harvest">
  <mat-icon>scale</mat-icon>
</button>
